export default "__VITE_ASSET__D96l8$gx__"